import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import { withModal } from 'components/modal/ModalHOC';

import CampaignParticipantsImportCollectionModal from '../import-collection-modal/CampaignParticipantsImportCollectionModal';

import { __t, applyTranslations } from 'utils/language';

import './campaign-participants-import-collection.scss';

applyTranslations(require('./campaign-participants-import-collection.i18n.json'));

type Props = {
  campaignId: number
};

const ActionButtonWithModal = withModal(ActionButton, {
  modalContent: CampaignParticipantsImportCollectionModal,
  showClose: false
});


class CampaignParticipantsImportCollection extends React.PureComponent<Props> {
  render() {
    const { campaignId } = this.props;

    return (
      <div className="campaign-participants-import-collection">
        <div className="campaign-participants-import-collection__title">
          {__t('campaign_participants_import_collection.title_label')}
        </div>
        <VerticalSpacing type="xlarge" />
        <div className="campaign-participants-import-collection__actions-section">
          <div className="campaign-participants-import-collection__action">
            <ActionButton
              width="maximum"
              link="/discovery/creators"
              newTab
            >
              {__t('campaign_participants_import_collection.discover_button_label')}
            </ActionButton>
          </div>
          <div className="campaign-participants-import-collection__action">
            <ActionButtonWithModal width="maximum" modalContentProps={{ campaignId }}>
              {__t('campaign_participants_import_collection.import_button_label')}
            </ActionButtonWithModal>
          </div>
        </div>
      </div>
    );
  }
}

export default CampaignParticipantsImportCollection;
